"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.types = __importStar(require("./types"));
var browser_grid_signals_1 = require("./browser-grid-signals");
Object.defineProperty(exports, "init", { enumerable: true, get: function () { return browser_grid_signals_1.init; } });
Object.defineProperty(exports, "getInstance", { enumerable: true, get: function () { return browser_grid_signals_1.getInstance; } });
Object.defineProperty(exports, "getInstanceProps", { enumerable: true, get: function () { return browser_grid_signals_1.getInstanceProps; } });
var grid_signals_1 = require("./grid-signals");
Object.defineProperty(exports, "GridSignals", { enumerable: true, get: function () { return grid_signals_1.default; } });
var browser_online_status_subscription_1 = require("./browser-online-status-subscription");
Object.defineProperty(exports, "getOnlineStatusSubscription", { enumerable: true, get: function () { return browser_online_status_subscription_1.getOnlineStatusSubscription; } });
/**
 * @deprecated Deprecated backwards compatibility helper functions, use 'getOnlineStatusSubscription' instead
 */
var is_online_deprecated_1 = require("./utils/is-online-deprecated");
Object.defineProperty(exports, "isOnline", { enumerable: true, get: function () { return is_online_deprecated_1.isOnline; } });
Object.defineProperty(exports, "isOnlineSubscription", { enumerable: true, get: function () { return is_online_deprecated_1.isOnlineSubscription; } });
const grid_signals_2 = __importDefault(require("./grid-signals"));
exports.default = grid_signals_2.default;
